<template>
  <el-menu class="navbar" mode="horizontal">
    <breadcrumb class="breadcrumb-container margin-left-15"></breadcrumb>
    <div class="right-menu">
      <TimeCount></TimeCount>
      <error-log class="errLog-container right-menu-item"></error-log>
      <template v-if="getUserInfo()">
        <el-dropdown class="avatar-container right-menu-item" trigger="hover">
          <div class="avatar-wrapper">
            <img class="user-avatar margin-right-10" :src="avatar">
            <span class="username">{{name || username}}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/">
              <el-dropdown-item>{{$t('navbar.dashboard')}}</el-dropdown-item>
            </router-link>
            <router-link v-show="isChannelAdminUser" :to="{name: 'channelManage'}">
              <el-dropdown-item>合作渠道管理</el-dropdown-item>
            </router-link>
            <router-link :to="{name: 'my-resetPassword'}">
              <el-dropdown-item>修改密码</el-dropdown-item>
            </router-link>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="right-menu-item">
          <el-button @click="logout">{{$t('navbar.logOut')}}</el-button>
        </div>
      </template>
      <div v-else>
        <div class="right-menu-item">
          <el-button type="primary" @click="$router.push({name: 'login'})">登录</el-button>
        </div>
      </div>
    </div>
  </el-menu>
</template>

<script>
import { getUserInfo } from '@/utils/user-info' // getToken from cookie
import permission from '@/directive/permission/index.js' // 权限判断指令
import { generateTitle } from '@/utils/i18n'
const { mapGetters } = Vuex
const Breadcrumb = () => import('@/components/Breadcrumb')
const ErrorLog = () => import('@/components/ErrorLog')
const TimeCount = () => import('@/components/TimeCount')

export default {
  components: {
    Breadcrumb,
    ErrorLog,
    TimeCount
  },
  directives: { permission },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'roles',
      'sidebar',
      'name',
      'avatar',
      'username',
      'permission_routers',
      'userMajorGetted',
      'userMajor',
      'isChannelAdminUser'
    ])
  },
  methods: {
    hasPermission (route) {
      if (route.meta && route.meta.roles) {
        return this.roles.some(role => route.meta.roles.indexOf(role) >= 0)
      } else {
        return true
      }
    },
    generateTitle: generateTitle,
    getUserInfo: getUserInfo,
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        window.location.reload()
        // window.location.href = window.location.origin
      })
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .no-enroll-alert-warp {
    float: right;
    display: flex;
    margin-right: 10px;
    .no-enroll-alert {
      width: auto;
      padding: 0;
      background: none;
    }
  }
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container{
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    display: flex;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .shoppingcart{
      height: 35px;
      overflow: hidden;
    }
    .international{
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      .avatar-wrapper {
        cursor: pointer;
        position: relative;
        height: 50px;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          vertical-align: middle;
        }
        .username {
          font-size: 14px;
          // position: absolute;
          // left: 50px;
          // top: -5px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -50px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue